import { render, staticRenderFns } from "./Indre.vue?vue&type=template&id=d361040a&"
import script from "./Indre.vue?vue&type=script&lang=js&"
export * from "./Indre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports